import {
  Box,
  Card,
  CardContent,
  CircularProgress,
  Container,
} from "@mui/material";
import "./App.css";
import Body from "./components/Body";
import Header from "./components/Header";
import Particle from "./components/Particles";
import SurveyChoice from "./pages/SurveyChoice";
import { makeStyles, useTheme } from "@mui/styles";
import illustration from "./assets/survey-illustration.png";
import { useState, useEffect } from "react";
import { CountdownCircleTimer } from "react-countdown-circle-timer";
import Survey from "./components/Survey";
import responseExample from "./assets/responseExample.json";
import { useMediaQuery } from "@mui/material";
import { useParams } from "react-router-dom";
import HasSubmitted from "./components/HasSubmitted";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: theme.spacing(3),
    background: "#263859",
    // backgroundImage: `url(${wallpaper})`,
    backgroundSize: "cover",

    minHeight: "100vh",
  },
  text: {
    color: "red",
  },
  paragraph: {
    fontSize: "1.2rem",
    [theme.breakpoints.up("md")]: {
      fontSize: "1.5rem",
    },
    [theme.breakpoints.up("lg")]: {
      fontSize: "2rem",
    },
  },
  timer: {
    position: "fixed",
    bottom: 10,
    right: 8,
    zIndex: 100,
    animation: "$move 3s ", // add animation
    // color: "white",
    fontWeight: "bold",
    fontSize: "2rem",
  },
  "@keyframes move": {
    "0%": {
      right: "100%", // start from the right
    },
    "100%": {
      right: 8, // move towards 0
    },
  },
}));
function App() {
  const [userLocation, setUserLocation] = useState(" ");
  let data = [];
  const [surveyData, setSurveyData] = useState(null);
  const params = useParams();
  const id = params.id;
  const [surveyError, setSurveyError] = useState(null);
  const [timerDone, setTimerDone] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(false);

  const [surveyIds, setSurveyIds] = useState([]);

  useEffect(() => {
    // Retrieve the survey IDs from localStorage and parse them into an array
    const storedSurveyIds = localStorage.getItem("surveyId");
    if (storedSurveyIds) {
      setSurveyIds(JSON.parse(storedSurveyIds));
    }
  }, []);

  useEffect(() => {
    const checkId = (idToCheck) => {
      if (surveyIds.includes(idToCheck)) {
        setHasSubmitted(true);
        console.log(`ID ${idToCheck} exists in the array.`);
      } else {
        console.log("test");
        // Perform an action if the ID does not exist in the array
      }
    };
    checkId(id);
  }, [surveyIds]);

  // let questions = responseExample.data.questions;

  async function getSurvey(id) {
    try {
      const response = await fetch(
        "https://foshizi.herokuapp.com/api/getsurveyid",
        {
          method: "POST",
          headers: {
            accept: "*/*",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: id,
          }),
        }
      );
      const data = await response.json();
      return data;
    } catch (error) {
      setSurveyData("error");
      console.log(surveyData);
      console.error(error);
    }
  }

  useEffect(() => {
    //get surveyId from the localstorage

    const localstorageData = localStorage.getItem("surveyId");
    console.log(localstorageData);
    async function fetchSurveyId() {
      data = await getSurvey(id);
      console.log(data);
      if (data.status === "bad") {
        setSurveyData("error");
      } else {
        setSurveyData(data.data.questions);
      }
    }
    fetchSurveyId();

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;

          // Make a request to the Google Maps Geocoding API
          const getLocation = async () => {
            const response = await fetch(
              `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=AIzaSyAJly_cEHCWHaLgQhYBL1wnr8V4qx7lqJE`
            );

            // Parse the response as JSON
            const data = await response.json();
            console.log(data)

            // Extract the formatted address from the response
            const address = data.results[0].formatted_address;
            console.log(address); // Prints "New York, NY, USA"
            setUserLocation(address);
          };
          getLocation();

          console.log(latitude, longitude);
        },
        (error) => {
          console.error(error);
        }
      );
    } else {
      console.error("Geolocation is not supported by this browser.");
    }
  }, []);
  const classes = useStyles();
  const theme = useTheme();

  const matchesSm = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const matchesMd = useMediaQuery((theme) =>
    theme.breakpoints.between("sm", "md")
  );
  const matchesLg = useMediaQuery((theme) => theme.breakpoints.up("lg"));

  const size = matchesSm ? 100 : matchesMd ? 130 : matchesLg ? 170 : 170;
  return (
    <Box
      sx={{
        // background: "#263859",
        minHeight: "100vh",
      }}
    >
      {/* <Particle /> */}
      <Header />

      {hasSubmitted ? (
        <HasSubmitted />
      ) : surveyData === "error" ? (
        // Display an error message if surveyData is "error"
        <Container>
          <Box
            sx={{
              display: "flex",
              background: "#263859",
              color: "white",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>Survey no longer available or closed.</h2>
          </Box>
        </Container>
      ) : surveyData ? (
        // Display the Survey component and the circular progress bar if surveyData is not null and not "error"
        <Box>
          <Survey
            data={surveyData}
            timerDone={timerDone}
            id={id}
            userLocation={userLocation}
          />
          <div className={classes.timer}>
            <CountdownCircleTimer
              size={size}
              isPlaying
              duration={600}
              colors={["#f98f19", "#F56833", "#FF0000"]}
              colorsTime={[100, 50, 0]}
              isGrowing={true}
              onComplete={() => {
                setTimerDone(true);
              }}
            >
              {({ remainingTime }) => remainingTime}
            </CountdownCircleTimer>
          </div>
        </Box>
      ) : (
        // Display a CircularProgress component if surveyData is null
        <Container>
          <Box
            sx={{
              minHeight: "50vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={200} />
          </Box>
        </Container>
      )}

      {/* 
      {surveyData === "error" ? (
        // Display an error message if surveyData is "error"
        <Container>
          <Box
            sx={{
              display: "flex",
              background: "#263859",
              color: "white",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <h2>Survey no longer available or closed.</h2>
          </Box>
        </Container>
      ) : surveyData ? (
        // Display the Survey component and the circular progress bar if surveyData is not null and not "error"
        <Box>
          <Survey
            data={surveyData}
            timerDone={timerDone}
            id={id}
            userLocation={userLocation}
          />
          <div className={classes.timer}>
            <CountdownCircleTimer
              size={size}
              isPlaying
              duration={600}
              colors={["#f98f19", "#F56833", "#FF0000"]}
              colorsTime={[100, 50, 0]}
              isGrowing={true}
              onComplete={() => {
                setTimerDone(true);
              }}
            >
              {({ remainingTime }) => remainingTime}
            </CountdownCircleTimer>
          </div>
        </Box>
      ) : (
        // Display a CircularProgress component if surveyData is null
        <Container>
          <Box
            sx={{
              minHeight: "50vh",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <CircularProgress size={200} />
          </Box>
        </Container>
      )} */}

      {/* <SurveyChoice /> */}
      {/* <Body /> */}
    </Box>
  );
}

export default App;
